import React, { useState } from "react";
import styled from "styled-components";
import Button from "./Button";
import Logo from "./Logo";
import { Link } from "react-router-dom";
import { account } from '../lib/appwrite'; // adjust the path to your Appwrite config
import { useNavigate } from 'react-router-dom';
import { toast } from "sonner";
import { useEffect } from "react";
import { PersonIcon } from "./svg/Icons";
import { getUserByDocument } from "../lib/actions";

const Section = styled.section`
  width: 100vw;
  background-color: ${(props) => props.theme.body};
`;
const NavBar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 90%;
  height: ${(props) => props.theme.navHeight};
  margin: 0 auto;

  .mobile {
    display: none;
  }

  @media (max-width: 64em) {
    .desktop {
      display: none;
      width: 100%;
      margin: 0;
    }
    .mobile {
      display: inline-block;
      width: 100%
      margin: 0;
    }
  }
  @media (max-width: 48em) {
    .desktop {
      display: none;
      width: 100%;
    }
    .mobile {
      display: inline-block;
      width: 100%
    }
  }
`;
const Menu = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style: none;

  @media (max-width: 64em) {
    /* 1024 px */

    position: fixed;
    top: ${(props) => props.theme.navHeight};
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
    z-index: 50;
    background-color: ${(props) => `rgba(${props.theme.bodyRgba},0.85)`};
    backdrop-filter: blur(2px);

    transform: ${(props) =>
      props.click ? "translateY(0)" : `translateY(1000%)`};
    transition: all 0.3s ease;
    flex-direction: column;
    justify-content: center;

    touch-action: none;
  }
`;

const MenuItem = styled.li`
  margin: 0 1rem;
  color: ${(props) => props.theme.text};
  cursor: pointer;

  &::after {
    content: " ";
    display: block;
    width: 0%;
    height: 2px;
    background: ${(props) => props.theme.text};
    transition: width 0.3s ease;
  }
  &:hover::after {
    width: 100%;
  }

  @media (max-width: 64em) {
    margin: 1rem 0;

    &::after {
      display: none;
    }
  }
`;
const HamburgerMenu = styled.span`
  width: ${(props) => (props.click ? "2rem" : "1.5rem")};

  height: 2px;
  background: ${(props) => props.theme.text};

  position: absolute;
  top: 2rem;
  left: 50%;
  transform: ${(props) =>
    props.click
      ? "translateX(-50%) rotate(90deg)"
      : "translateX(-50%) rotate(0)"};

  display: none;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  transition: all 0.3s ease;

  @media (max-width: 64em) {
    /* 1024 px */
    display: flex;
  }

  &::after,
  &::before {
    content: " ";
    width: ${(props) => (props.click ? "1rem" : "1.5rem")};
    height: 2px;
    right: ${(props) => (props.click ? "-2px" : "0")};
    background: ${(props) => props.theme.text};
    position: absolute;
    transition: all 0.3s ease;
  }

  &::after {
    top: ${(props) => (props.click ? "0.3rem" : "0.5rem")};
    transform: ${(props) => (props.click ? "rotate(-40deg)" : "rotate(0)")};
  }
  &::before {
    bottom: ${(props) => (props.click ? "0.3rem" : "0.5rem")};
    transform: ${(props) => (props.click ? "rotate(40deg)" : "rotate(0)")};
  }
`;

const Navigation = () => {
  const [click, setClick] = useState(false);
  // const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  console.log(isLoggedIn);
  

  useEffect(() => {
    const token = localStorage.getItem('userId');
    if (!token) {
      setIsLoggedIn(false);
    }
    setIsLoggedIn(!!token); // true if token exists
  }, []);

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchuser = async () => {
      try {
        const raw = localStorage.getItem('userId')
        if (raw) {
          const id = JSON.parse(raw)
          const userData = await getUserByDocument(id);
          setData(userData);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }
    fetchuser();
  }, [isLoggedIn])

  const name = data ? data.name : "";
  const username = data? data.username : "null";
  const firstName = name.match(/^\S+/)?.[0] || "";
  const scrollTo = (id) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      setClick(false);
    } else {
      // Navigate to the homepage with hash
      window.location.href = `/#${id}`;
    }
  };

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await account.deleteSession('current'); // End Appwrite session
    } catch (err) {
      console.warn('Session already deleted or not logged in:', err);
    }

    localStorage.removeItem('user'); // Or use clear() if you want to remove all
    localStorage.removeItem('userId'); // Or use clear() if you want to remove all
    toast.success('Logged out successfully');
    navigate('/login'); // Redirect to login or homepage
  };

  return (
    <Section id="navigation">
      <NavBar>
        <Logo />
        <HamburgerMenu click={+click} onClick={() => setClick(!click)}>
          &nbsp;
        </HamburgerMenu>
        <Menu click={+click}>
          <MenuItem onClick={() => scrollTo("home")}>Home</MenuItem>
          {/* <MenuItem onClick={() => scrollTo("about")}>About</MenuItem> */}
          {/* <MenuItem onClick={() => scrollTo("roadmap")}>Roadmap</MenuItem> */}
          <MenuItem onClick={() => navigate('/clubs')}>Club</MenuItem>
          {isLoggedIn ? (
          <Link to={'/creator/' + username}> <MenuItem >Creator</MenuItem></Link>
          ) : (<></>)}
          <Link to='/explore'> <MenuItem >Explore</MenuItem></Link>
          
          {/* <MenuItem onClick={() => scrollTo("team")}>Team</MenuItem> */}
          {/* <MenuItem onClick={() => scrollTo("faq")}>Faq</MenuItem> */}
          <MenuItem onClick={() => navigate('/create-art')}>Create NFT</MenuItem>
          {isLoggedIn ? (
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          ) : (
            <MenuItem onClick={() => navigate('/login')}>Login</MenuItem>
          )}
          {isLoggedIn ? (
            <MenuItem>
            <div className="mobile">
              <Link to="/dashboard">
              <Button text={ <>
                    <PersonIcon width={48} height={24}/>
                    {firstName.toUpperCase()}
                  </>  } />                   
              </Link>
            </div>
          </MenuItem>
          ): (
            <MenuItem>
              <div className="mobile">
                <Link to="/connect-wallet">
                  <Button text="Connect Wallet"/> 
                </Link>
              </div>
            </MenuItem>
          )}
          
        
        </Menu>
        <div className="desktop">
          {isLoggedIn ? (
            <div>
              <Link to="/dashboard">
                <Button text={ <>
                    <PersonIcon width={48} height={24}/>
                    {firstName.toUpperCase()}
                  </>  } />              
              </Link>
            </div>
          ) : (
            <Link to="/connect-wallet">
              <Button text="Connect Wallet" /> 
            </Link>
          )}
        </div>
      </NavBar>
    </Section>
  );
};

export const Navigation2 = () => {
  // const [click, setClick] = useState(false);
  // const location = useLocation();

  // const scrollTo = (id) => {
  //   const element = document.getElementById(id);

  //   if (element) {
  //     element.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //       inline: "nearest",
  //     });
  //     setClick(false);
  //   } else {
  //     // Navigate to the homepage with hash
  //     window.location.href = `/#${id}`;
  //   }
  // };

  return (
    <Section id="navigation2">
      <NavBar>
        <Logo />
        {/* <HamburgerMenu click={+click} onClick={() => setClick(!click)}>
          &nbsp;
        </HamburgerMenu>
        <Menu click={+click}>
          <MenuItem onClick={() => scrollTo("home")}>Home</MenuItem>
          <MenuItem onClick={() => scrollTo("about")}>About</MenuItem>
          <MenuItem onClick={() => scrollTo("roadmap")}>Roadmap</MenuItem>
          <MenuItem onClick={() => scrollTo("showcase")}>Showcase</MenuItem>
          <MenuItem onClick={() => scrollTo("team")}>Team</MenuItem>
          <MenuItem onClick={() => scrollTo("faq")}>Faq</MenuItem>
          <MenuItem >Logout</MenuItem>
          <MenuItem>
            <div className="mobile">
              <Link to="/connect-wallet">
                <Button text="Connect Wallet" /> 
              </Link>
            </div>
          </MenuItem>
        </Menu>
        <div className="desktop">
          <Link to="/connect-wallet">
            <Button text="Connect Wallet" /> 
          </Link>
        </div> */}
      </NavBar>
    </Section>
  );
};
export default Navigation;
